// Summernote labels the toolbar from the document selection at init time, which
// is still outside the editor, so it shows an unrelated font until the first
// click. Re-label from the editable's own computed style instead.
export function syncToolbarFontLabels(
  $container: any,
  editableEl: HTMLElement | null | undefined,
  fontNames?: string[],
): void
{
  if (!$container || !editableEl) return;

  const $toolbar = $container.find('.note-toolbar');
  if (!$toolbar.length) return;

  const computed = window.getComputedStyle(editableEl);

  const families = computed.fontFamily
    .split(',')
    .map(name => name.replace(/['"]/g, '').trim())
    .filter(Boolean);

  // Prefer a family the picker offers, so the label matches a dropdown entry
  const configured = fontNames ?? [];
  const fontName =
    families.find(family =>
      configured.some(option => option.toLowerCase() === family.toLowerCase()),
    ) ?? families[0];

  if (fontName)
  {
    $toolbar.find('.note-current-fontname').text(fontName).css('font-family', fontName);
  }

  const fontSize = parseInt(computed.fontSize, 10);
  if (!Number.isNaN(fontSize))
  {
    $toolbar.find('.note-current-fontsize').text(String(fontSize));
    $toolbar.find('.note-current-fontsizeunit').text('px');
  }
}
